import { History } from "lucide-react";

export default function ModuleLog({ item }) {
  const history = [...(item.history || [])].reverse();
  return (
    <div className="mt-4 border-t border-navy/10 pt-4" data-testid="module-log">
      <div className="flex items-center gap-2 overline text-navy/40 mb-3"><History className="w-3.5 h-3.5" /> Bitácora de actividad</div>
      {history.length === 0 ? (
        <p className="text-sm text-navy/40" data-testid="module-log-empty">Sin movimientos registrados.</p>
      ) : (
        <ol className="relative border-l border-navy/10 ml-1.5 space-y-3">
          {history.map((h, i) => (
            <li key={i} className="ml-4" data-testid={`module-log-entry-${i}`}>
              <span className="absolute -left-1.5 w-3 h-3 rounded-full bg-violet border-2 border-white" />
              <div className="text-sm text-navy/80">
                <span className="font-medium">{h.by}</span> {h.action}
                {h.estado ? <span className="badge badge-violet ml-1.5">{h.estado}</span> : null}
              </div>
              <div className="text-[11px] text-navy/40">{new Date(h.at).toLocaleString("es-MX")}</div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
